export default __webpack_public_path__ + "static/media/BG.087e9ee2.svg";